module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Tous les avantages Beauty Insider',
        signIn: 'Ouvrir une session',
        signInSubText: 'pour voir vos points et profiter des récompenses.',
        applyText: 'Appliquer',
        samplesText: 'Choisissez jusqu’à 2 échantillons gratuits',
        samplesSubText: '0 de 2 ajouté pour la livraison',
        noBiPoints: 'Vous avez maintenant <b>0</b> points Beauty Insider.',
        biPoints: `Vous avez actuellement <b>${vars[0]} points</b>`,
        cxsMissingMessage: 'Beauty Insider nʼest pas disponible pour le moment. Veuillez revenir plus tard.'
    };

    return resources[label];
};
